import { laptopMax, laptopMaxXL, laptopMin, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { Box } from '../layout';
import { ItalicText, MidHeading, Text } from '../typography';

export const Container = styled.section`
  padding: 110px 20px 15px 20px;
`;

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1110px;
`;

export const Section = styled.div`
  display: flex;
  gap: 80px;
  flex-direction: column-reverse;

  @media (${laptopMaxXL}) {
    gap: 40px;
  }

  @media (${laptopMin}) {
    flex-direction: row;
    align-items: center;

    & > :nth-child(1),
    > :nth-child(2) {
      flex-basis: 50%;
      width: 50%;
    }
  }
`;

export const SectionImageContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SectionImage = styled.img`
  width: 100%;
  max-width: 520px;
`;

export const ContentSection = styled(Box)`
  ${MidHeading} {
    color: ${({ theme }) => theme.primary};
  }
  ${ItalicText} {
    color: ${({ theme }) => theme.textDark};
  }

  @media (${laptopMax}) {
    ${MidHeading}, ${Text} {
      text-align: center;
    }
  }
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  max-width: 520px;
  margin: 0 auto;

  @media (${mobileXXLargeMax}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const Card = styled.div`
  padding: 15px 10px;
  text-align: center;
  box-shadow: 2px 2px 8px 0 rgba(153, 153, 153, 0.5);
  border-radius: 6px;
`;
